import { atom } from 'recoil';
import { CustomerWithId } from '~/types/platform/customer';

const customer = atom<Partial<CustomerWithId>>({
  key: 'customer',
  default: {
    displayName: '',
    phoneNumber: '',
    containers: {},
    birthday: '',
    email: '',
  },
});

export default customer;
